import request from '@/utils/request'

let Inspection_typeApi = {

  /*隐患排查类型列表*/
  list(data) {
    return request._post('/shop/plus.inspection_type.Index/index', data);
},
/*添加隐患排查类型*/
add(data) {
    return request._post('/shop/plus.inspection_type.Index/add', data);
},
/*修改隐患排查类型*/
edit(data) {
    return request._post('/shop/plus.inspection_type.Index/edit', data);
},
/*删除隐患排查类型*/
del(data) {
    return request._post('/shop/plus.inspection_type.Index/del', data);
},
/*隐患排查类型详情*/
detail(data) {
  return request._post('/shop/plus.inspection_type.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.inspection_type.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.inspection_type.Setting/getSetting', data, errorback);
    },
}
export default Inspection_typeApi;



// WEBPACK FOOTER //
// ./src/api/inspection_type.js